if (!customElements.get('wls-benefits-accordion')) {
  class WLSBenefitsAccordion extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        accordionItem: 'wls-benefits-accordion__item',
        accordionTrigger: '.wls-benefits-accordion__trigger',
        accordionContent: '.wls-benefits-accordion__content',
        container: '.wls-benefits-accordion__container',
        imageWrapper: '.wls-benefits-accordion__image-wrapper',
        accordionWrapper: '.wls-benefits-accordion__accordion-wrapper',
        desktopImages: '.wls-benefits-accordion__image-img',
        activeImage: 'wls-benefits-accordion__image-img--active',
        noActiveImage: 'wls-benefits-accordion__container--no-active-image',
      };

      function debounce(fn, wait) {
        let t;
        return function (...args) {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      this.boundResizeHandler = debounce(this.handleResize.bind(this), 250);
      this.boundAccordionToggle = this.handleAccordionToggle.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.boundResizeHandler);
      
      const accordion = this.querySelector('wls-accordion');
      if (accordion) {
        accordion.addEventListener('click', this.boundAccordionToggle);
      }
    }

    disconnectedCallback() {
      this.teardown();
      window.removeEventListener('resize', this.boundResizeHandler);
      
      const accordion = this.querySelector('wls-accordion');
      if (accordion) {
        accordion.removeEventListener('click', this.boundAccordionToggle);
      }
    }

    init() {
      this.selectors = {
        accordionItems: this.querySelectorAll(`.${this.classes.accordionItem}`),
        desktopImages: this.querySelectorAll(this.classes.desktopImages),
        container: this.querySelector(this.classes.container),
        imageWrapper: this.querySelector(this.classes.imageWrapper),
        accordionWrapper: this.querySelector(this.classes.accordionWrapper),
      };

      if (!this.selectors.accordionItems || this.selectors.accordionItems.length === 0) return;

      this.updateLayout();

      this.fixAccordionHeights();
    }

    handleResize() {
      this.updateLayout();
      this.fixAccordionHeights();
    }

    handleAccordionToggle() {
      setTimeout(() => {
        this.updateLayout();
        this.fixAccordionHeights();
      }, 100);
    }

    fixAccordionHeights() {
      this.selectors.accordionItems.forEach((item) => {
        const content = item.querySelector(this.classes.accordionContent);
        if (!content) return;

        const isExpanded = item.hasAttribute('data-expanded');
        
        if (isExpanded) {
          content.style.maxHeight = 'none';
          const height = content.scrollHeight;
          content.style.maxHeight = `${height}px`;
        }
      });
    }

    updateLayout() {
      const { container, imageWrapper, accordionWrapper, accordionItems } = this.selectors;
      
      if (!container || !accordionItems || accordionItems.length === 0) return;

      if (window.innerWidth < 768) return;

      const activeItem = this.querySelector(`.${this.classes.accordionItem}` + '[data-expanded="true"]');
      if (!activeItem) return;

      const hasImage = activeItem.getAttribute('data-image-url') && 
                       activeItem.getAttribute('data-image-url') !== '';

      if (this.selectors.desktopImages && this.selectors.desktopImages.length > 0) {
        const activeIndex = Array.from(accordionItems).indexOf(activeItem);
        this.selectors.desktopImages.forEach((img, index) => {
          if (index === activeIndex && hasImage) {
            img.classList.add(this.classes.activeImage);
          } else {
            img.classList.remove(this.classes.activeImage);
          }
        });
      }

      if (hasImage && imageWrapper) {
        container.classList.remove(this.classes.noActiveImage);
      } else {
        container.classList.add(this.classes.noActiveImage);
      }
    }
  }

  window.customElements.define('wls-benefits-accordion', WLSBenefitsAccordion);
}
